const flights = {
  flight: "Vuelo", // translated
  flights: "Vuelos", // translated
  originDepartureDate: "Partida", // translated
  destinationDepartureDate: "Devolver", // translated
  outbound: "saliente", // translated
  inbound: "Entrante", // translated
  travelTime: "Tiempo de viaje", // translated
  selected: "seleccionado", // translated
  select: "seleccionar", // translated
  airline: "Aerolínea", // translated
  directFlight: "Vuelo directo", // translated
  baggage: "equipaje", // translated
  stops: "Paradas", // translated
  nonStop: "Sin escalas", // translated
  oneStopMax: "Una parada máxima", // translated
  twoStopsMax: "Dos paradas máximo", // translated
  anyStops: "Con cualquier parada", // translated
  smallBaggage: "equipaje pequeño", // translated
  bigBaggage: "equipaje grande", // translated
  smallAndBigBaggage: "Equipaje pequeño y grande", // translated
  outboundStops: "Paradas de ida", // translated
  inboundStops: "Paradas entrantes", // translated
  selectAirline: "Seleccionar aerolínea", // translated
  baggageOption: "Opción de equipaje", // translated
  outboundDepartureAfter: "Salida de ida después", // translated
  outboundArrivalAfter: "Llegada de salida después", // translated
  inboundDepartureAfter: "Salida entrante después", // translated
  inboundArrivalTimeAfter: "Llegada entrante después", // translated
  flightClass: "clase de vuelo", // translated
  outboundDepAfter: "Salida después", // translated
  outboundArrivalAfrer: "Llegada después", // translated
  inboundDepAfter: "En salida después", // translated
  inboundArrivalAfter: "Al llegar después", // translated
  airlines: "Aerolíneas)", // translated
  lessThan: "Menos que", // translated
  layover: "Escala", // translated
  duration: "Duración", // translated
  economy: "Economía", // translated
  business: "Negocio", // translated
  with: "Con", // translated
  without: "Sin", // translated
  twoOrMore: "Dos o más", // translated
  departure: "Partida", // translated
  return: "Devolver", // translated
  submit: "Entregar", // translated
  priceLessThan: "Precio inferior a", // translated
  durationLessThan: "Duración inferior a", // translated
  layoverLessThan: "Escala inferior a", // translated
  noLayover: "Sin escala", // translated
  durationLowestFirst: "Duración (la más baja primero)", // translated
  durationHighestFirst: "Duración (la más alta primero)", // translated
  idType: "tipo de identificación", // translated
  idPassportCode: "Código de identificación/pasaporte", // translated
  expirationDate: "Fecha de caducidad", // translated
  frequentFlyerNumber: "Número de viajero frecuente", // translated
  frequentFlyerAirline: "Aerolínea de viajero frecuente", // translated
  dateOfBirth: "Fecha de nacimiento", // translated
  infant: "Niño", // translated
  phone: "Teléfono", // translated
  title: "Título", // translated
  noLuggageIncluded: "No incluye equipaje", // translated
  includesLuggage: "Incluye Equipaje", // translated
  outboundFlight: "Vuelo de ida", // translated
  inboundFlight: "Vuelo entrante", // translated
  flightNumber: "Número de vuelo", // translated
  flightNumbers: "Números de vuelo", // translated
  cabinClassType: "Tipo de clase de cabina", // translated
  aircraftType: "Tipo de aeronave", // translated
  airlineName: "Nombre de la aerolínea", // translated
  no: "No", // translated
  yes: "Sí", // translated
  anyFlights: "Cualquier vuelo", // translated
  oneStop: "Una parada", // translated
  direct: "Directo", // translated
  directFlights: "Vuelos directos", // translated
  all: "Todo", // translated
  first: "Primero", // translated
  premiumEconomy: "Prem. Economía", // translated
  withBaggageOnly: "Sólo con equipaje", // translated
  oneWay: "De una sola mano", // translated
  roundTrip: "Ida y vuelta", // translated
  withBaggage: "Con equipaje", // translated
  noBaggage: "Sin equipaje", // translated
  requiredFields: "Campos requeridos", // translated
  nonRequiredFields: "Campos no obligatorios", // translated
  cabinClass: "Clase económica", // translated
  brandName: "Nombre de la marca", // translated
  performNewSearch: "Realizar una nueva búsqueda", // translated
  outboundDeparture: "Salida de ida", // translated
  inboundDeparture: "Salida entrante", // translated
  created: "Creado", // translated
  freeCancellationAvailable: "Cancelación gratuita disponible", // translated
  freeCancellationDeadline: "Fecha límite de cancelación gratuita", // translated
  externalReference: "Referencia externa", // translated
  outboundflightNumber: "Número de vuelo de ida", // translated
  inboundflightNumber: "Número de vuelo entrante", // translated
  arrival: "Llegada", // translated
};


export default flights;
